module.exports = __webpack_public_path__ + "img/will.397faf89.svg";